import Id from './Id';
import Name from './Name';
import Created from './Created';
import Updated from './Updated'
import Shops from './Shops';

export const labels = {
  Id: 'Azonosító',
  Name: 'Név',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
  Shops: 'Üzletek'
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'Shops'
},
];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'Shops'
}];

export const defaultSort = {
  prop: Name.propName,
  order: 'ascending'
};

export default {
  Id,
  Name,
  Updated,
  Created,
  Shops,
}
